module.exports = {
  async getSeasonSettingToday() {
    const url = `${this.url}/${this.version}/season_setting/today`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
}



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/season_setting_api.js